export const DEFAULT_REACTIONS = [
  "1f44d", // 👍
  "2764-fe0f", // ❤️
  "1f603", // 😃
  "1f622", // 😢
  "1f64f", // 🙏
  "1f44e", // 👎
  "1f621" // 😡
];
